import * as tslib_1 from "tslib";
import { EntityStore, StoreConfig } from '@datorama/akita';
import * as i0 from "@angular/core";
var SoilAnalysisUploadStore = /** @class */ (function (_super) {
    tslib_1.__extends(SoilAnalysisUploadStore, _super);
    function SoilAnalysisUploadStore() {
        return _super.call(this, { loading: false, error: null }) || this;
    }
    SoilAnalysisUploadStore.ngInjectableDef = i0.defineInjectable({ factory: function SoilAnalysisUploadStore_Factory() { return new SoilAnalysisUploadStore(); }, token: SoilAnalysisUploadStore, providedIn: "root" });
    SoilAnalysisUploadStore = tslib_1.__decorate([
        StoreConfig({ name: 'soil-analysis-upload', resettable: true }),
        tslib_1.__metadata("design:paramtypes", [])
    ], SoilAnalysisUploadStore);
    return SoilAnalysisUploadStore;
}(EntityStore));
export { SoilAnalysisUploadStore };
